/* global FULL_DATE_FORMAT */
import React, { Component } from 'react'
import dayjs from 'dayjs'
import classnames from 'classnames'
import _ from 'lodash'
import OrderDetail from '../../../generic/OrderDetail'
import SubscriptionTransactions from '../SubscriptionTransactions'
import keyUpHandler from '../../../utils/keyUpHandler'
import './styles.css'

class CollapsibleOrder extends Component {
  static getHumanReadableStatus(status = '') {
    switch (status) {
      case 'authorization_expired':
      case 'failed':
      case 'gateway_rejected':
      case 'processor_declined':
      case 'settlement_declined':
      case 'settlement_failed':
      case 'unrecognized':
        return 'Failed'
      case 'authorizing':
      case 'authorized':
      case 'settlement_pending':
      case 'settlement_confirmed':
      case 'settling':
      case 'submitted_for_settlement':
        return 'Processing'
      case 'settled':
        return 'Completed'
      case 'voided':
        return 'Voided'
      default:
        return 'Not available'
    }
  }

  constructor(props) {
    super(props)
    this.state = { visible: false }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState({ visible: !this.state.visible })
  }

  render() {
    const { props } = this
    const { isSubscription, isTransaction } = props
    const status = isTransaction ? CollapsibleOrder.getHumanReadableStatus(props.status) : 'Completed'
    return (
      <div
        className={classnames('collapsible-order', {
          collapsed: !this.state.visible,
          'is-transaction': isTransaction
        })}
      >
        <div
          aria-label="Toggle order details"
          className="order-summary"
          onClick={() => this.toggle()}
          onKeyUp={event => keyUpHandler(event, this.toggle, null, this)}
          tabIndex="0"
        >
          <div className="left-container">
            <button
              aria-label={this.state.visible ? 'Collapse' : 'Expand'}
              className={classnames({ animate: this.state.visible })}
            >
              <i className="icon-right-2" />
            </button>
            {!isSubscription && (
              <div className="order-date">
                {dayjs(isTransaction ? props.createdAt : props.created).format(FULL_DATE_FORMAT)}
              </div>
            )}
            {isSubscription && (
              <div className="subscription-name">
                {`${props.plan} subscription`}
                {props.active && <span className="active">[Active]</span>}
                {!props.active && <span className="inactive">[Inactive]</span>}
              </div>
            )}
          </div>
          {!isSubscription && (
            <div className="order-id">
              <span>{isTransaction ? props.id : props.braintreeId}</span>
            </div>
          )}
          {!isSubscription && (
            <div className="status">
              <span className={status.toLowerCase()}>{status}</span>
            </div>
          )}
          {!isSubscription && (
            <div className="price">
              ${isTransaction ? props.amount : props.cost}
            </div>
          )}
        </div>
        {this.state.visible && (
          <>
            {!isSubscription && (
              <OrderDetail
                {...props}
                isLoaded={_.has(props, 'items') || isTransaction}
                showFullDetail
                isMobile={props.isMobile}
                subscriptionTransaction={isTransaction}
                subscription={props.subscription}
              />
            )}
            {isSubscription && (
              <SubscriptionTransactions
                subscription={props}
                isMobile={props.isMobile}
                isLoaded={_.has(props, 'transactions')}
              />
            )}
          </>
        )}
      </div>
    )
  }
}

export default CollapsibleOrder
